import React, { FC, memo } from 'react'
import { classNames, toPriceLittleCurrency } from '@dt/fe-utils'
import './index.scss'

// props
interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 原价 */
  price?: number;
  /** 实际价格-- actualPrice */
  actualPrice?: number;
  /** 控制营销价格的展示与否（用于解决有stepper时可能会遮住营销价格） */
  /** 此属性和marketPrice是否有值不产生关联性 */
  hideMarketPrice?: boolean;
  /** 售罄不展示营销价 */
  soldOut?: boolean;
  /** 会员价 */
  memberPrice?: number;
  /** 优惠价格 */
  offPrice?: number;
  /** 会员价登录有的优惠 */
  isMemberDiscount?: boolean;
  /** 装修配置 */
  decorate?: TMealCommonDecorates;
  /** 字号 */
  fontSize?: number;
  /** 字重 */
  fontWeight?: any;
}

const Price: FC<IProps> = ({ className, fontSize: _fontSize, fontWeight: _fontWeight, price, actualPrice, hideMarketPrice, soldOut, memberPrice = 0, offPrice = 0, isMemberDiscount, decorate }) => {
  const formatOriginPrice = toPriceLittleCurrency(price)
  const formatMarketPrice = toPriceLittleCurrency(actualPrice)
  const fontSize = _fontSize || decorate?.fontSetting?.price?.fontSize || 16
  const isFontWeight = decorate?.fontSetting?.price?.fontWeight || 0
  const priceComponent = function (formatPrice: string, textThrough: boolean = false) {
    // 举例：
    // 原价  38
    // 折扣  23
    // 会员  22
    // 第一个显示：只有原价，仅显示原价 38
    // 第二个显示：如果没有会员价，显示  23  38
    // 第三个显示：如果仅有会员价，没有折扣价
    // 如果登录会员  V22，38
    // 如果未登录显示  38   V22
    // 第四个显示：有会员价和折扣价的时候
    // 会员价 < 折扣价       未登录显示  23  38
    // 登录显示  V22  38
    // 会员价 > = 折扣价  比如会员价  30 ；折扣价29
    // 未登录显示  29 ， 38
    // 登录显示  29 ， 38
    return (
      <div
        className={classNames(
          'price-wrap',
          {
            'text-through': textThrough,
            'hide': textThrough && hideMarketPrice
          }
        )}
      >
        <span className='price' dangerouslySetInnerHTML={{ __html: formatPrice }}></span>
      </div>
    )
  }
  return (
    <div
      className={classNames(
        'use-price',
        className,
        {
          'has-market-price': actualPrice,
          'sold-out': soldOut
        }
      )}
      style={{ fontWeight: _fontWeight || (isFontWeight ? 700 : 500), fontSize: `${fontSize}px` }}
    >
      {
        isMemberDiscount ? (
          <div className='member-price'>
            <i className='member-icon'>VIP</i>
            <span dangerouslySetInnerHTML={{ __html: toPriceLittleCurrency(actualPrice) }}></span>
          </div>
        ) : (
          priceComponent(formatMarketPrice)
        )
      }
      {
        !soldOut && offPrice && memberPrice < 0 ? (
          priceComponent(formatOriginPrice, true)
        ) : null
      }
      {
        memberPrice > 0 && !hideMarketPrice ? (
          <div className='member-price small'>
            <i className='member-icon'>VIP</i>
            <span dangerouslySetInnerHTML={{ __html: toPriceLittleCurrency(memberPrice) }}></span>
          </div>
        ) : null
      }
    </div>
  )
}

export default memo(Price)
